import { AlertTriangle, CheckCircle, XCircle, Info } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatusBannerProps {
  type: 'success' | 'warning' | 'error' | 'info';
  title?: string;
  description: string;
  className?: string;
}

export function StatusBanner({ type, title, description, className }: StatusBannerProps) {
  const configs = {
    success: {
      icon: CheckCircle,
      bgClass: 'bg-emerald-50 border-emerald-200',
      iconClass: 'text-emerald-600',
      titleClass: 'text-emerald-900',
      descClass: 'text-emerald-700'
    },
    warning: {
      icon: AlertTriangle,
      bgClass: 'bg-amber-50 border-amber-200',
      iconClass: 'text-amber-600',
      titleClass: 'text-amber-900', 
      descClass: 'text-amber-700'
    },
    error: {
      icon: XCircle,
      bgClass: 'bg-red-50 border-red-200',
      iconClass: 'text-red-600',
      titleClass: 'text-red-900',
      descClass: 'text-red-700'
    },
    info: {
      icon: Info,
      bgClass: 'bg-blue-50 border-blue-200',
      iconClass: 'text-blue-600',
      titleClass: 'text-blue-900',
      descClass: 'text-blue-700'
    }
  };

  const config = configs[type];
  const Icon = config.icon;

  return (
    <div className={cn(
      "rounded-lg border p-4",
      config.bgClass,
      className
    )}>
      <div className="flex items-start gap-3">
        <Icon className={cn("h-5 w-5 mt-0.5", config.iconClass)} />
        <div className="flex-1">
          {title && (
            <h3 className={cn("text-sm font-medium", config.titleClass)}>
              {title}
            </h3>
          )}
          <p className={cn("text-sm", title ? "mt-1" : "", config.descClass)}>
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}